module.exports = __webpack_public_path__ + "static/media/logo.697c7f5c.png";